import { Component } from './component.js';

export class Label extends Component {
  static defaultOptions = {
    componentName: 'Label',
    tagName: 'label'
  };

  constructor (options) {
    super($.extend({}, Label.defaultOptions, options));
    this.setText(this.options.text);
  }

  setText (text) {
    if (!text) return;
    this.el.text(text);
  }
}
